import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const I_KEYBOARDING_AFFIRMATION_FRAGMENT = gql `
  fragment IKeyboardingAffirmationFragment on IKeyboardingAffirmation {
    affirmationAudio {
      ...AssetFragment
    }
  }
  ${ASSET_FRAGMENT}
`;
export default I_KEYBOARDING_AFFIRMATION_FRAGMENT;
